export const routePaths = {
  login: "Login",
  organisations: "organisations",
  groups: "groups",
  updatePassword: "update-password",
  logoff: "logoff",
  qrLogin: "qr-login",
  loginAssistant: "assistant"
};
